import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY } from '../constants/company';

const Col = ({ title, links }) => (
  <div>
    <h4 className="font-bold mb-4 text-white">{title}</h4>
    <ul className="space-y-2">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to || '#link'} className="text-sm text-white/70 hover:text-white transition-colors">{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => {
  const currentYear = Math.max(new Date().getFullYear(), new Date(COMPANY.incorporatedOn).getFullYear());
  return (
    <footer className="bg-[#1F0068] text-white pt-20 pb-8 rounded-t-[48px]">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-white/10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <svg viewBox="0 0 40 40" className="w-10 h-10">
                <circle cx="20" cy="20" r="20" fill="#FF5C39" />
                <path d="M12 22 L18 28 L28 14" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <div className="leading-tight">
                <div className="font-bold text-lg">Domestic Home</div>
                <div className="text-[10px] tracking-[0.22em] text-white/60 uppercase font-semibold">Services</div>
              </div>
            </div>
            <p className="text-sm text-white/70 max-w-md leading-relaxed">
              UK maintenance and repair service plans for household appliances, boilers, plumbing and drainage. Arranged through our network of independent service providers. These plans are maintenance service agreements — not insurance products.
            </p>

            <div className="mt-6 space-y-2 text-sm text-white/80">
              <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#FF5C39]" /> <a href={`tel:${COMPANY.phoneTel}`} className="hover:underline">{COMPANY.phoneShort}</a></div>
              <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#FF5C39]" /> <a href={`mailto:${COMPANY.supportEmail}`} className="hover:underline">{COMPANY.supportEmail}</a></div>
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#FF5C39] mt-0.5" /> <span><span className="uppercase tracking-widest text-[10px] text-white/60 block">Registered Office</span>{COMPANY.registeredOffice.full}</span></div>
            </div>

            <div className="mt-6">
              <Link to="/quote">
                <Button data-testid="footer-get-quote" className="rounded-full bg-[#FF5C39] hover:bg-[#e0492b] text-white h-11 px-6 font-semibold">
                  Get a quick quote
                </Button>
              </Link>
            </div>
          </div>

          <Col title="Service Plans" links={[
            { label: 'Appliance Service Plans', to: '/appliance-cover' },
            { label: 'Home Emergency', to: '/home-emergency' },
            { label: 'Boiler & Heating', to: '/boiler-cover' },
            { label: 'Get a quote', to: '/quote' },
          ]} />
          <Col title="Company" links={[
            { label: 'About us', to: '/about' },
            { label: 'Contact', to: '/contact' },
            { label: 'Help centre', to: '/help' },
            { label: 'Agent Portal', to: '/agent/login' },
          ]} />
          <Col title="Legal & Policies" links={[
            { label: 'Terms & Conditions', to: '/legal/terms' },
            { label: 'Privacy Policy', to: '/legal/privacy' },
            { label: 'Cancellation Policy', to: '/legal/cancellation-policy' },
            { label: 'Refund Policy', to: '/legal/refund-policy' },
            { label: 'Complaints Procedure', to: '/legal/complaints' },
            { label: 'Compliance', to: '/legal/compliance' },
            { label: 'Vulnerable Customer Policy', to: '/legal/vulnerable-customer' },
          ]} />
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/60 max-w-3xl leading-relaxed" data-testid="footer-legal-line">
            © {currentYear} {COMPANY.name}. All rights reserved. {COMPANY.name} is a company registered in England &amp; Wales (Company No. {COMPANY.companyNumber}). Registered Office: {COMPANY.registeredOffice.full}. Our plans are maintenance service agreements and are not insurance products. Repair and maintenance visits are arranged through our network of independent UK service providers.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
